import React, { Component } from 'react';
import { useParams } from "react-router-dom";
import {Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from "./components/Home";
import Persons from "./components/Persons";
import Stuffs from "./components/Stuffs";
import Invoices from "./components/Tax/Invoices";
import InvoiceView from "./components/Tax/InvoiceView";
import Login from "./components/Login";
import Register from "./components/Register";
import Remember from "./components/Remember";
import Profile from "./components/Profile";
import Company from "./components/Company";
import CompanyUsers from "./components/Base/CompanyUsers";
import CompanyModule from "./components/Base/CompanyModule";
import CompanyModules from "./components/Base/CompanyModules";
import InquiryEconomicCode from "./components/InquiryEconomicCode";
import InquiryStuff from "./components/InquiryStuff";
import MyInvoices from "./components/MyInvoices";
import MyInvoice from "./components/MyInvoice";
import MyOrders from "./components/MyOrders";
import PaymentFailed from "./components/PaymentFailed";
import MyTransactions from "./components/MyTransactions";
import PaySlips from "./components/PaySlips";
import PaySlipsExcel from "./components/PaySlipsExcel";
import PaySlipsMy from "./components/PaySlipsMy";
import PaySlip from "./components/PaySlip";
import PaySlipPreview from "./components/PaySlipPreview";
import EmploymentOrdersMy from "./components/EmploymentOrdersMy";
import EmploymentOrders from "./components/EmploymentOrders";
import EmploymentOrder from "./components/EmploymentOrder";
import EmploymentOrderPreview from "./components/EmploymentOrderPreview";
import OrgPosts from "./components/OrgPosts";
import OrgPost from "./components/OrgPost";
import OrgUnits from "./components/OrgUnits";
import ContractsMy from "./components/ContractsMy";
import Contracts from "./components/Contracts";
import ContractPreview from './components/ContractPreview';
import Tickets from "./components/Tickets";
import Ticket from './components/Ticket';
import CSR from "./components/CSR";
import Referral from "./components/Referral";
import Affiliate from "./components/Affiliate";
import BuyModules from "./components/BuyModules";
import BuySmsCredit from "./components/BuySmsCredit";
import TimeSheetsMy from "./components/TimeSheetsMy";
import TimeSheetsReport from "./components/TimeSheetsReport";
import TimeSheetHeaders from "./components/TimeSheetHeaders";
import EmployeeWorkStationGroups from "./components/EmployeeWorkStationGroups";
import EmployeeWorkStationGroup from './components/EmployeeWorkStationGroup';
import EmployeeWorkStations from "./components/EmployeeWorkStations";
import EmployeeWorkStation from './components/EmployeeWorkStation';
import Order from "./components/Order";
import Chats from './components/Chats';
import MyWallet from './components/MyWallet';

import OrderViews from './components/OrderViews';
import Warehouses from './components/Warehouses';
import ProductionLines from './components/Ordering/ProductionLines';
import Factors from "./components/Accountings/Factors";
import InsurancePolicies from "./components/Commerce/InsurancePolicies";
import BillOfLadings from "./components/Commerce/BillOfLadings";
import CustomsClearances from "./components/Commerce/CustomsClearances";
import FullPrices from "./components/Commerce/FullPrices";
import Banks from "./components/Accountings/Banks";
import Currencies from "./components/Accountings/Currencies";
import Supplies from "./components/Accountings/Supplies";
import PriceAnnouncements from "./components/PriceAnnouncements/PriceAnnouncements";
import StockTakings from "./components/StockTakings/StockTakings";
import Constants from "./components/Constants";
import BankAccounts from "./components/BankAccounts";
import ChequePrintTemplates from "./components/Accountings/ChequePrintTemplates";
import CashDesks from "./components/CashDesks";
import Documents from "./components/Accountings/Documents"; 
import AccountsMappings from "./components/Accountings/AccountsMappings";
import Branches from "./components/Accountings/Branches";
import Remittances from "./components/Accountings/Remittances";
import Remittance from "./components/Accountings/Remittance";
import Receipts from "./components/Accountings/Receipts";
import BalanceReport from "./components/BalanceReport";
import IncomeReport from "./components/IncomeReport";
import CapitalReport from "./components/CapitalReport";
import JournalReport from "./components/JournalReport";
import LedgerReport from "./components/LedgerReport";
import TrialbalanceReport from "./components/TrialbalanceReport";
import ExploreReport from "./components/ExploreReport";
import TransctionsOverviewReport from "./components/TransctionsOverviewReport";
import TransctionsReport from "./components/TransctionsReport";
import DebcredReport from "./components/DebcredReport";
import TransactionReport from "./components/TransactionReport";
import TransactionsReport from "./components/TransactionsReport";
import BankTransactionReport from "./components/BankTransactionReport";
import CashTransactionReport from "./components/CashTransactionReport";
import Cheques from './components/Accountings/Cheques';
import Units from "./components/Units";
import Buildings from "./components/Buildings/Buildings";
import UnitBills from "./components/Buildings/UnitBills";
import UnitAggregatedBills from "./components/Buildings/UnitAggregatedBills";
import BuildingMyReceipts from "./components/Buildings/MyReceipts";
import Estates from "./components/Estates/Estates";
import Users from "./components/Managments/Users";
import User from "./components/Managments/User";
import Escalations from "./components/Managments/Escalations";
import Escalation from "./components/Managments/Escalation";
import SalaryBases from "./components/Managments/SalaryBases";
import SalaryBase from "./components/Managments/SalaryBase";
import SalaryMonthSettings from "./components/Managments/SalaryMonthSettings";
import SalaryMonthSetting from "./components/Managments/SalaryMonthSetting";
import Transactions from "./components/Managments/Transactions";
import Supports from "./components/Managments/Supports";
import Support from './components/Managments/Support';
import SystemModulePrices from './components/Managments/SystemModulePrices';
import Settings from './components/Managments/Settings';
import MyDocuments from "./components/MyDocuments";
import Withdrawals from "./components/Managments/Withdrawals";
import Withdrawal from './components/Managments/Withdrawal';
import SystemReportHeaders from './components/Managments/SystemReportHeaders';
import FM from './components/Managments/FM';
import BaseStuffs from "./components/Managments/BaseStuffs";
import Accounts from './components/Accountings/Accounts';
import Tafsils from './components/Accountings/Tafsils';
import Solutions from './components/Solution/Solutions';
import MyTasks from './components/Solution/MyTasks';
import SolutionBoard from './components/Solution/SolutionBoard';
import Annual from './components/Accountings/Annual';
import Annuals from './components/Accountings/Annuals';
import AnnualClose from './components/Accountings/AnnualClose';
import StuffCardex from './components/Accountings/StuffCardex';
import StuffInventoryTurnover from './components/Accountings/StuffInventoryTurnover';

import CrmCaseList from './components/Crm/CrmCaseList';
import CrmCases from './components/Crm/CrmCases';
import CrmTeams from './components/Crm/CrmTeams';

import Campaigns from './components/Campaign/Campaigns';

import Orderings from './components/Ordering/Orderings';
import ProductionCalendar from './components/Productions/ProductionCalendar';
import ProductionTrackings from './components/Productions/ProductionTrackings';

import Salaries from './components/SalaryMan/Salaries';

import Meetings from "./components/Meetings";
import Reports from './components/Reports/Reports';
import ReportViewer from './components/Reports/ReportViewer';
import SmsTemplates from './components/Managments/SmsTemplates';
import AppMenus from './components/Base/AppMenus';
import AppActions from './components/Base/AppActions';
import Andikators from "./components/Secretariat/Andikators";
import Letters from "./components/Secretariat/Letters";
import Forms from "./components/Secretariat/Forms";
import QuestionnaireView from "./components/Questionnaires/QuestionnaireView";
import Questionnaire from "./components/Questionnaires/Questionnaire";
import Questionnaires from "./components/Questionnaires/Questionnaires";

import OrganWorkingGroup from "./components/Organization/OrganWorkingGroup";
import OrganWorkingGroups from "./components/Organization/OrganWorkingGroups";
import OrganCharts from "./components/Organization/OrganCharts";

import OtherReportViewer from "./components/OtherReportViewer";
import CompanyUserGroups from "./components/Base/CompanyUserGroups";

import Bulletins from "./components/Bulletins/Bulletins";
import Leaves from "./components/Leaves/Leaves";
import ReportSaleStuffs from "./components/Accountings/ReportSaleStuffs";
import ReportSaleStuffsDetail from "./components/Accountings/ReportSaleStuffsDetail";

import AffiliateMarketingPlans from "./components/AffiliateMarketings/AffiliateMarketingPlans";
import APIList from "./components/API/APIList";

import ToDoList from "./components/ToDo/ToDoList";
import Installments from "./components/Installment/Installments";
import RestaurantTables from "./components/Restaurant/RestaurantTables";
import RestaurantMenuCategories from "./components/Restaurant/RestaurantMenuCategories";

import ContractingContracts from "./components/Contracting/ContractingContracts";
import ContractingProgressClaims from "./components/Contracting/ContractingProgressClaims";

import CustomerClubLevels from "./components/Club/CustomerClubLevels";
import CustomerClubRewards from "./components/Club/CustomerClubRewards";

import AggregateEvents from "./components/AggregateEvents";
import UserLogs from "./components/UserLogs";

import Curriculums from './components/Lms/Curriculum/Curriculums';

import EmployeeEnterExits from './components/HRM/EmployeeEnterExit/EmployeeEnterExits';

import WorkFlows from './components/BPMS/WorkFlows';

function LettersWrapper(props) {
    const { folderId, filter } = useParams();

    return <Letters key={folderId + filter} {...props} Filter={filter == undefined ? 0 : parseInt(filter)} LetterFolderId = { folderId == undefined ? '00000000-0000-0000-0000-000000000000' : folderId} />;
}

export default class App extends Component {
    getDefaultGuid() {
        return '00000000-0000-0000-0000-000000000000';
    }
  render() {
    return (
      <Layout>
            <Routes>
                <Route exact path='/' element={<Home />} />

                <Route path="/bpms/workflows/" element={<WorkFlows />}></Route>
                                
                <Route path="/curriculums/" element={<Curriculums />}></Route>

                <Route path="/employeeenterexits/" element={<EmployeeEnterExits />}></Route>

                <Route path="/userlogs/" element={<UserLogs />}></Route>

                <Route path="/aggregate/meetings/" element={<AggregateEvents Type={1} InternalType={0} />}></Route>

                <Route path="/club/levels/" element={<CustomerClubLevels />}></Route>
                <Route path="/club/rewards/" element={<CustomerClubRewards />}></Route>

                <Route path="/restaurant/tables/" element={<RestaurantTables />}></Route>
                <Route path="/restaurant/menu/" element={<RestaurantMenuCategories />}></Route>                

                <Route path="/contracting/contracts/" element={<ContractingContracts />}></Route>
                <Route path="/contracting/progressclaims/" element={<ContractingProgressClaims />}></Route>

                <Route path="/installments/" element={<Installments />}></Route>
                <Route path="/todo/" element={<ToDoList />}></Route>
                
                <Route path='/login' element={<Login BackUrl={"/"} />} />

                <Route path='/register' element={<Register />} />

                <Route path='/remember' element={<Remember />} />
                <Route path='/profile' element={<Profile />} />
                <Route path='/buy/modules' element={<BuyModules />} />
                <Route path='/buy/sms/credit' element={<BuySmsCredit />} />

                <Route path='/bulletins' element={<Bulletins />} />
                <Route path='/leaves' element={<Leaves />} />

                <Route path='/forms/1' element={<Forms Type={1} />} />
                <Route path='/forms/2' element={<Forms Type={2} />} />
                <Route path='/forms/3' element={<Forms Type={3} />} />
                
                <Route path='/myinvoice/view/:id' element={<MyInvoice Inp={0} Id={1} Ins={0} IsNew={false} />} />
                <Route path='/myinvoices' element={<MyInvoices />} />
                
                <Route path='/myorders' element={<MyOrders />} />
                <Route path='/order' element={<Order />} />
                                
                <Route path='/referral' element={<Referral />} />
                <Route path='/affiliate' element={<Affiliate />} />
                <Route path='/csr' element={<CSR />} />
                <Route path='/chats/:contact_id' element={<Chats Id={1} />} />
                <Route path='/chats' element={<Chats />} />          

                <Route path='/affiliate/marketing/plans' element={<AffiliateMarketingPlans />} />
                <Route path='/api' element={<APIList />} />

                <Route path='/orderviews' element={<OrderViews IsMy={false} />} />
                <Route path='/myorderviews' element={<OrderViews IsMy={true} />} />
                <Route path='/warehouses' element={<Warehouses />} />
                <Route path='/productionlines' element={<ProductionLines />} />
                
                <Route path='/tafsils' element={<Tafsils />} />
                <Route path='/accounts' element={<Accounts />} />
                <Route path='/bankaccounts' element={<BankAccounts />} />
                <Route path='/chequeprinttemplate' element={<ChequePrintTemplates />} />      
                <Route path='/cashdesks' element={<CashDesks />} />
                <Route path='/accounttypes' element={<Constants Type={7} />} />
                <Route path='/personcategories' element={<Constants Type={1} />} />
                <Route path='/stuffcategories' element={<Constants Type={2} />} />
                <Route path='/documenttypes' element={<Constants Type={4} />} />
                <Route path='/bulletincategories' element={<Constants Type={11} />} />
                <Route path='/salefacortypes' element={<Constants Type={12} />} />
                <Route path='/buycontracttypes' element={<Constants Type={13} />} />            
                
                <Route path='/accounts/mapping' element={<AccountsMappings />} />
                <Route path='/branches' element={<Branches />} />
                <Route path='/menues' element={<AppMenus id={1} />} />
                <Route path='/menues/:id' element={<AppMenus id={1} />} />

                <Route path='/actions' element={<AppActions id={1} />} />

                <Route path='/report/others' element={<OtherReportViewer />} />

                <Route path='/report/balance' element={<BalanceReport />} />
                <Route path='/report/income' element={<IncomeReport />} />
                <Route path='/report/capital' element={<CapitalReport />} />
                <Route path='/report/journal' element={<JournalReport />} />
                <Route path='/report/ledger' element={<LedgerReport />} />
                <Route path='/report/trialbalance' element={<TrialbalanceReport />} />

                <Route path='/report/explore' element={<ExploreReport Id={this.getDefaultGuid()} IsReverse={false} />} />
                <Route path='/report/explore1/:id' element={<ExploreReport Id={1} IsReverse={false} />} />
                <Route path='/report/explore2/:id' element={<ExploreReport Id={1} IsReverse={false} />} />
                <Route path='/report/explore3/:id' element={<ExploreReport Id={1} IsReverse={false} />} />
                <Route path='/report/explore1u/:id' element={<ExploreReport Id={1} IsReverse={true} />} />
                <Route path='/report/explore2u/:id' element={<ExploreReport Id={1} IsReverse={true} />} />
                <Route path='/report/explore3u/:id' element={<ExploreReport Id={1} IsReverse={true} />} />

                <Route path='/report/transactions/overview/:id/:parentId' element={<TransctionsOverviewReport Id={1} />} />

                <Route path='/report/transactions/:id' element={<TransctionsReport Id={1} Level={1} />} />
                <Route path='/report/transactions/:id/:parentId' element={<TransctionsReport Id={1} Level={2} />} />
                <Route path='/report/transactions/:id/:id2/:parentId' element={<TransctionsReport Id={1} Level={3} />} />

                <Route path='/report/debcred' element={<DebcredReport />} />
                <Route path='/report/transaction/:tafsiltype/:tafsilcode' element={<TransactionReport />} />
                <Route path='/report/transactions' element={<TransactionsReport />} />
                <Route path='/report/banktransaction' element={<BankTransactionReport />} />
                <Route path='/report/cashtransaction' element={<CashTransactionReport />} />
                <Route path='/report/sale/stuffs' element={<ReportSaleStuffs />} />
                <Route path='/report/sale/stuffs/detail' element={<ReportSaleStuffsDetail />} />

                <Route path='/system/headers' element={<SystemReportHeaders />} />
                
                {/*<Route path='/remittance/new1' element={<Remittance IO={1} Id={this.getDefaultGuid()} />} />*/}
                {/*<Route path='/remittance/new2' element={<Remittance IO={2} Id={this.getDefaultGuid()} />} />*/}
                <Route path='/remittance/edit/:id' element={<Remittance Id={1} />} />
                <Route path='/remittances/out' element={<Remittances IO={2} />} />
                <Route path='/remittances/in' element={<Remittances IO={1} />} />
                <Route path='/remittances/transfer' element={<Remittances IO={3} />} />

                <Route path='/documents' element={<Documents IsTemplate={false} IsReference={false} />} />
                <Route path='/referencedocuments' element={<Documents IsTemplate={false} IsReference={true} />} />
                <Route path='/documenttemplates' element={<Documents IsTemplate={true} IsReference={false } />} />

                <Route path='/receipts' element={<Receipts Type={0} />} />
                <Route path='/receipts/in' element={<Receipts Type={1} />} />
                <Route path='/receipts/out' element={<Receipts Type={2} />} />
                <Route path='/receipts/in/book' element={<Receipts Type={3} />} />
                <Route path='/receipts/transfer' element={<Receipts Type={4} />} />
                <Route path='/receipts/daily' element={<Receipts Type={5} />} />

                <Route path='/cheques/in' element={<Cheques Type={1} />} />
                <Route path='/cheques/out' element={<Cheques Type={2} />} />

                <Route path='/buildings/' element={<Buildings />} />
                <Route path='/building/bills/all/' element={<UnitBills ForMe={false} />} />
                <Route path='/building/bills/my/' element={<UnitBills ForMe={true} />} />
                <Route path='/building/bills/aggregated/all/' element={<UnitAggregatedBills ForMe={false} />} />
                <Route path='/building/bills/aggregated/my/' element={<UnitAggregatedBills ForMe={true} />} />
                <Route path='/building/receipts/my/' element={<BuildingMyReceipts />} />
                
                <Route path='/estates/' element={<Estates />} />

                <Route path='/banks' element={<Banks />} />
                <Route path='/currencies' element={<Currencies />} />

                <Route path='/fullprices' element={<FullPrices />} />
                <Route path='/insurancepolicies' element={<InsurancePolicies />} />
                <Route path='/billofladings' element={<BillOfLadings />} />
                <Route path='/customsclearances' element={<CustomsClearances />} />

                <Route path='/factors/buy' element={<Factors Type={1} />} />
                <Route path='/factors/buy/foreign' element={<Factors Type={6} />} />
                <Route path='/factors/sale' element={<Factors Type={2} />} />
                <Route path='/factors/buyreturn' element={<Factors Type={3} />} />
                <Route path='/factors/salereturn' element={<Factors Type={4} />} />
                <Route path='/factors/waste' element={<Factors Type={5} />} />
                <Route path='/factors/buy/service' element={<Factors Type={7} />} />
                <Route path='/factors/sale/service' element={<Factors Type={8} />} />

                <Route path='/supplies/internal' element={<Supplies Type={1} />} />
                <Route path='/supplies/orders' element={<Supplies Type={2} />} />

                <Route path='/priceannouncements' element={<PriceAnnouncements />} />
                <Route path='/stocktakings' element={<StockTakings />} />

                <Route path='/invoice/view/:id' element={<InvoiceView Inp={0} Id={1} Ins={0} IsNew={false} />} />
                <Route path='/invoices' element={<Invoices />} />

                <Route path='/persons' element={<Persons Caller="persons" />} />
                <Route path='/customers' element={<Persons Caller="customers" />} />
                <Route path='/staffs' element={<Persons Caller="staffs" />} />
                
                <Route path='/company/new' element={<Company Id={this.getDefaultGuid()} />} />
                <Route path='/company/edit/:id' element={<Company Id={1} />} />
                <Route path='/company/setting' element={<Company Id={1} />} />
                
                <Route path='/company/users' element={<CompanyUsers />} />

                <Route path='/stuffs' element={<Stuffs />} />

                <Route path='/employeeworkstationgroup/new' element={<EmployeeWorkStationGroup Id={this.getDefaultGuid()} />} />
                <Route path='/employeeworkstationgroup/edit/:id' element={<EmployeeWorkStationGroup Id={1} />} />
                <Route path='/employeeworkstationgroups' element={<EmployeeWorkStationGroups />} />

                <Route path='/employeeworkstation/new' element={<EmployeeWorkStation Id={this.getDefaultGuid()} />} />
                <Route path='/employeeworkstation/edit/:id' element={<EmployeeWorkStation Id={1} />} />
                <Route path='/employeeworkstations' element={<EmployeeWorkStations />} />

                <Route path='/payslip/new' element={<PaySlip Id={this.getDefaultGuid()} />} />
                <Route path='/payslip/edit/:id' element={<PaySlip Id={1} />} />
                <Route path='/payslip/preview/:id' element={<PaySlipPreview Id={1} />} />
                <Route path='/payslips/excel' element={<PaySlipsExcel />} />
                <Route path='/payslips/my' element={<PaySlipsMy />} />
                <Route path='/payslips' element={<PaySlips />} />

                <Route path='/employmentorder/new' element={<EmploymentOrder Id={this.getDefaultGuid()} />} />
                <Route path='/employmentorder/edit/:id' element={<EmploymentOrder Id={1} />} />
                <Route path='/employmentorder/preview/:id' element={<EmploymentOrderPreview Id={1} />} />
                <Route path='/employmentorders/my' element={<EmploymentOrdersMy />} />            
                <Route path='/employmentorders' element={<EmploymentOrders />} />

                <Route path='/timesheets/' element={<TimeSheetHeaders />} /> 
                <Route path='/timesheets/my' element={<TimeSheetsMy />} />
                <Route path='/timesheets/report' element={<TimeSheetsReport />} />     
                
                <Route path='/orgunits' element={<OrgUnits />} />

                <Route path='/orgpost/new' element={<OrgPost Id={this.getDefaultGuid()} />} />
                <Route path='/orgpost/edit/:id' element={<OrgPost Id={1} />} />
                <Route path='/orgposts' element={<OrgPosts />} />

                <Route path='/contract/preview/:id' element={<ContractPreview Id={1} />} />
                <Route path='/contracts/my' element={<ContractsMy />} />
                <Route path='/contracts' element={<Contracts />} />

                <Route path='/inquiry/economiccode/' element={<InquiryEconomicCode />} />
                <Route path='/inquiry/stuff/' element={<InquiryStuff />} />

                <Route path='/mytransactions' element={<MyTransactions />} />

                <Route path='/paymentfailed/' element={<PaymentFailed />} />                

                <Route path='/ticket/new' element={<Ticket Id={this.getDefaultGuid()} />} />
                <Route path='/ticket/edit/:id' element={<Ticket Id={1} />} />
                <Route path='/tickets' element={<Tickets />} />

                <Route path='/mydocuments' element={<MyDocuments IsChild={false} />} />

                <Route path='/company/module/new' element={<CompanyModule Id={0} />} />
                <Route path='/company/module/edit/:id' element={<CompanyModule Id={1} />} />
                <Route path='/company/modules' element={<CompanyModules />} />
                                
                <Route path='/systemmoduleprices' element={<SystemModulePrices />} />
                <Route path='/settings' element={<Settings />} />

                <Route path='/user/new' element={<User Id={this.getDefaultGuid()} />} />
                <Route path='/user/edit/:id' element={<User Id={1} />} />
                <Route path='/users' element={<Users />} />

                <Route path='/units' element={<Units />} />

                <Route path='/escalation/new' element={<Escalation Id={0} />} />
                <Route path='/escalation/edit/:id' element={<Escalation Id={1} />} />
                <Route path='/escalation' element={<Escalations />} />

                <Route path='/salarybase/new' element={<SalaryBase Id={0} />} />
                <Route path='/salarybase/edit/:id' element={<SalaryBase Id={1} />} />
                <Route path='/salarybase' element={<SalaryBases />} />

                <Route path='/salarymonthsetting/new' element={<SalaryMonthSetting Id={0} />} />
                <Route path='/salarymonthsetting/edit/:id' element={<SalaryMonthSetting Id={1} />} />
                <Route path='/salarymonthsetting' element={<SalaryMonthSettings />} />
                                
                <Route path='/mywallet' element={<MyWallet />} />
                
                <Route path='/smstemplates' element={<SmsTemplates IsGlobal={true} />} />
                <Route path='/company/smstemplates' element={<SmsTemplates IsGlobal={false} />} />

                <Route path='/withdrawal/edit/:id' element={<Withdrawal Id={1} />} />
                <Route path='/withdrawals' element={<Withdrawals />} />

                <Route path='/transactions' element={<Transactions />} />
                <Route path='/basestuffs' element={<BaseStuffs />} />
                <Route path='/fm' element={<FM />} />

                <Route path='/support/new' element={<Support Id={this.getDefaultGuid()} />} />
                <Route path='/support/edit/:id' element={<Support Id={1} />} />
                <Route path='/supports' element={<Supports />} />


                <Route path='/solutions' element={<Solutions />} />
                <Route path='/solution/board/:id' element={<SolutionBoard />} />
                <Route path='/solution/my/tasks' element={<MyTasks />} />

                <Route path='/annuals' element={<Annuals />} />
                <Route path='/annual/new' element={<Annual Id={this.getDefaultGuid()} />} />
                <Route path='/annual/edit/:id' element={<Annual Id={1} />} />
                <Route path='/annual/close' element={<AnnualClose />} />

                <Route path='/stuff/cardex' element={<StuffCardex />} />
                <Route path='/stuff/inventory/turnover' element={<StuffInventoryTurnover />} />

                <Route path='/crm/cases/archived' element={<CrmCaseList Archived={true} Blacklist={false} />} />
                <Route path='/crm/cases/blacklist' element={<CrmCaseList Archived={false} Blacklist={true} />} />
                <Route path='/crm/cases/:id' element={<CrmCases Id={1} />} />
                <Route path='/crm/teams/' element={<CrmTeams />} />

                <Route path='/reports' element={<Reports />} />
                <Route path='/reports/view/:id' element={<ReportViewer Id={1} />} />
                
                <Route path='/salaries' element={<Salaries />} />

                <Route path='/orderings/buy' element={<Orderings Department={"acc"} Type={4} />} />
                <Route path='/orderings/buy/foreign' element={<Orderings Department={"acc"} Type={8} />} />

                <Route path='/ordering' element={<Orderings Department={"acc"} Type={1}  />} />
                <Route path='/ordering/review' element={<Orderings Department={"warehouse"} Type={1} />} />
                <Route path='/crm/ordering/' element={<Orderings Department={"crm"} Type={1} />} />
                <Route path='/proformainvoice/' element={<Orderings Department={""} Type={2} />} />
                
                <Route path='/orders/analize/' element={<Orderings Department={""} Type={5} />} />

                <Route path='/production/orders/' element={<Orderings Department={"production_orders"} Type={3} />} />
                <Route path='/production/planing/' element={<Orderings Department={"production_planing"} Type={3} />} />
                <Route path='/production/list/' element={<Orderings Department={""} Type={7} />} />
                <Route path='/production/calendar/' element={<ProductionCalendar />} />

                <Route path='/production/trackings/' element={<ProductionTrackings ReportMode={1} />} />
                <Route path='/production/trackings2/' element={<ProductionTrackings ReportMode={2} />} />
                
                <Route path='/campaigns/system' element={<Campaigns IsOrganization={false} />} />
                <Route path='/campaigns/companies' element={<Campaigns IsOrganization={true} />} />

                <Route path='/andikators' element={<Andikators />} />
                <Route path='/letters/my' element={<LettersWrapper CallerSection="my" />} />
                <Route path='/letters/my/filter/:filter' element={<LettersWrapper CallerSection="my" />} />
                <Route path='/letters/all/my/filter/:filter' element={<LettersWrapper CallerSection="in_out_internal" />} />
                <Route path='/letters/my/:folderId' element={<LettersWrapper CallerSection="my" />} />                
                <Route path='/letters/internal' element={<LettersWrapper CallerSection="internal" />} />
                <Route path='/letters/out' element={<LettersWrapper CallerSection="out" />} />
                <Route path='/letters/in' element={<LettersWrapper CallerSection="in" />} />
                <Route path='/letters/all' element={<LettersWrapper CallerSection="all" />} />
                
                <Route path='/questionnaire/new' element={<Questionnaire Id={this.getDefaultGuid()} />} />
                <Route path='/questionnaire/edit/:id' element={<Questionnaire Id={1} />} />
                <Route path='/questionnaires' element={<Questionnaires />} />
                <Route path='/q/:id' element={<QuestionnaireView />} />

                <Route path='/organworkinggroups/new' element={<OrganWorkingGroup Id={this.getDefaultGuid()} />} />
                <Route path='/organworkinggroups/edit/:id' element={<OrganWorkingGroup Id={1} />} />
                <Route path='/organworkinggroups' element={<OrganWorkingGroups />} />

                <Route path='/organchart' element={<OrganCharts />} />
                <Route path='/meetings' element={<Meetings ForMe={false} />} />
                <Route path='/meetings/my' element={<Meetings ForMe={true} />} />

                <Route path='/usergroups' element={<CompanyUserGroups />} />
        </Routes>
      </Layout>
    );
  }
}